<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" :to="{ name : 'investment.home' }">
                <img src="/img/brand/logo.png">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <router-link :to="{ name : 'investment.home' }">
                        <!--<img src="img/brand/blue.png">-->
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://iieg.mujeresyjusticiafiscal.org">
                        INICIO
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://mujeresyjusticiafiscal.org/publicaciones/" target="_blank">
                        PUBLICACIONES
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://mujeresyjusticiafiscal.org/materiales/" target="_blank">
                        MATERIALES
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://mujeresyjusticiafiscal.org/noticias/" target="_blank">
                        NOTICIAS
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://mujeresyjusticiafiscal.org/videos/" target="_blank">
                        RECURSOS
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://mujeresyjusticiafiscal.org/contacto/" target="_blank">
                        CONTACTO
                    </a>
                </li>                
            </ul>

        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
.navbar-brand img {
    height: 80px !important;
}
.section-shaped .shape-style-1.shape-default, .bg-gradient-default {
    background: linear-gradient(150deg, #a148af 15%, #873693 70%, #63236d 94%) !important;
}
</style>
